<template>
  <v-app>
    <v-navigation-drawer
      :clipped="$vuetify.breakpoint.lgAndUp"
      fixed
      temporary
      app
      dark
      v-model="drawer"
    >
      <v-list>
          <v-list-item exact :to="{name: 'home'}">
            <v-list-item-action>
               <v-icon class="green--text">mdi-home</v-icon>
            </v-list-item-action>
            <v-list-item-title>In Bearbeitung</v-list-item-title>
          </v-list-item>
        
          <v-list-item :to="{name: 'new'}">
            <v-list-item-action>
               <v-icon class="blue--text">mdi-account-plus</v-icon>
            </v-list-item-action>
            <v-list-item-title>Neu verstorben</v-list-item-title>
          </v-list-item>

          <v-list-item :to="{name: 'cendres'}">
            <v-list-item-action>
               <v-icon color="teal lighten-2">mdi-fire</v-icon>
            </v-list-item-action>
            <v-list-item-title>Asche</v-list-item-title>
          </v-list-item>

          <v-list-item :to="{name: 'archives'}">
            <v-list-item-action>
               <v-icon class="orange--text">mdi-archive</v-icon>
            </v-list-item-action>
            <v-list-item-title>Archiv</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-action>
               <v-switch v-model="$vuetify.theme.dark"></v-switch>
            </v-list-item-action>
            <v-list-item-title>Nacht-Modus</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-action>
               <v-btn icon @click="logout"><v-icon class="red--text">mdi-logout</v-icon></v-btn>
            </v-list-item-action>
            <v-list-item-title>{{this.user.name + " ("+ this.user.group +")"}}</v-list-item-title>
          </v-list-item>
          
      </v-list>
    </v-navigation-drawer>
    <v-app-bar 
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      dark
      app
      fixed
      class="brown"
      >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Serenity</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu
        align-content-center
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-btn style="margin-left:150px" large rounded outlined v-on="on">{{date2}}</v-btn>
        </template>
        <v-date-picker readonly locale="de-CH" v-model="date" @input="menu = false"></v-date-picker>
      </v-menu>
      <v-spacer></v-spacer>
      <v-img src="../src/assets/logo.png"  alt="logo" max-width="45px" class="mr-1"></v-img>
      <strong class="hidden-sm-and-down">Bestattungsdienst-sense.ch</strong>
    </v-app-bar>
    <v-main>
      <v-container fluid grid-list-lg>
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
      </v-container>
    </v-main>
    <v-footer app fixed>
      <span>&copy; {{ (new Date()).getFullYear() }} — SebSolutions</span>
    </v-footer>
    <v-dialog dark v-model="modal" persistent max-width="400">
      <v-card :color="modalColor">
        <v-card-title class="headline">
          {{title}}
        </v-card-title>
        <v-card-text>{{message}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="modal = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
  // import {ajax_post} from '../public/global.js'
  import currentUser from "./store/currentUser"
  export default {
    data () {
      return {
        drawer: false,
        date: new Date().toISOString().substr(0, 10),
        date2 : new Date().toLocaleDateString(),
        menu: false,
        modal: false,
        modalColor: 'success',
        title: '',
        message:'',
        user: currentUser.user
      }
    },
    methods: {
      logout (){
        localStorage.removeItem('token')
        sessionStorage.removeItem('token')
        currentUser.user.id = ''
        currentUser.user.group = ''
        currentUser.user.name = ''
        this.$router.push({name: 'login'})
      }
    },
    created () {
      // this.recupUser()
      this.$root.$on('myinfo', (val) =>{
          // console.log('Titre : ' + val.title + ' --- Message : ' + val.msg)
          this.title = val.title
          this.message = val.msg
          val.color !== "" ? this.modalColor = val.color : this.modalColor = "success"
          this.modal = true
      })
    }
  }
</script>